import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { ListMetadata } from '../../models/list-metadata.model';
import { URLSearchParams } from '@angular/http';
import { ParamOchannel } from '../../models/promotion-param-ochannel.model';


@Injectable()
export class PromotionParamOchannelService {

  public baseUrl = '/koncentro-loyalty';

  constructor(
    private http: HttpClientService
  ) { }

  get(paramId, oChannelId): Observable<ParamOchannel> {
    return this.http.get(this.baseUrl + '/params/' + paramId + '/ochannel/' + oChannelId);
  }

  list(paramId, offset = null, limit = null, search?: Array<{ key: string, value: string }>): Observable <{data: Array<ParamOchannel>, metadata: ListMetadata}> {
    const params: URLSearchParams = new URLSearchParams();
    if (search) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }

    if ( offset !== null ) {
      params.set('offset', offset.toString());
    }
    if ( limit !== null ) {
      params.set('limit', limit.toString());
    }

    return this.http.get(this.baseUrl + '/params/' + paramId + '/ochannel?' + params.toString());
  }

  update(oChannel: ParamOchannel): Observable<ParamOchannel> {

    return this.http.put(this.baseUrl + '/params/' + oChannel.param_id + '/ochannel/' + oChannel.ochannel_id, oChannel);
  }

  create(oChannel: ParamOchannel): Observable<ParamOchannel> {    
    return this.http.post(this.baseUrl + '/params/' + oChannel.param_id + '/ochannel/' + oChannel.ochannel_id, oChannel );
  }

  remove(paramId, oChannelId): Observable<ParamOchannel> {
    return this.http.delete(this.baseUrl + '/params/' + paramId  + '/ochannel/' + oChannelId);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-param-ochannel.service.ts